import React from 'react';

type PageLayoutWidth = 'full' | 'content';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  width?: PageLayoutWidth;
}

const WIDTH_CLASS: Record<PageLayoutWidth, string> = {
  full: 'w-full',
  content: 'max-w-[88rem]',
};

export default function PageLayout({ children, className = '', width = 'full' }: PageLayoutProps) {
  const classes = [
    WIDTH_CLASS[width],
    'mx-auto',
    'px-page-gutter md:px-10',
    'py-8 md:py-10',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {children}
    </div>
  );
}
